import { FirebaseDocRefType } from 'firebase/index'
import { BreadType } from 'types/bread'
import { ScheduleType } from 'types/schedule'
import { StockType } from 'types/stock'
import { StaffType } from 'types/staff'

export const CLOSE_MODAL = 'CLOSE_MODAL'
export const closeModalAction = () => {
  return {
    type: 'CLOSE_MODAL',
    payload: null,
  }
}

export const CLOSE_CAUTION_MODAL = 'CLOSE_CAUTION_MODAL'
export const closeCautionModalAction = () => {
  return {
    type: 'CLOSE_CAUTION_MODAL',
    payload: null,
  }
}

export const CLOSE_CONFIRM_MODAL = 'CLOSE_CONFIRM_MODAL'
export const closeConfirmModalAction = () => {
  return {
    type: 'CLOSE_CONFIRM_MODAL',
    payload: {
      confirm: false,
    },
  }
}

export const CLOSE_SHARED_BREAD_MODAL = 'CLOSE_SHARED_BREAD_MODAL'
export const closeSharedBreadModalAction = () => {
  return {
    type: 'CLOSE_SHARED_BREAD_MODAL',
    payload: {
      retailerBreads: [],
      open: false,
      edited: false,
    },
  }
}

export const CLOSE_STAFF_MODAL = 'CLOSE_STAFF_MODAL'
export const closeStaffModalAction = () => {
  return {
    type: 'CLOSE_STAFF_MODAL',
    payload: {
      open: false,
      staff: undefined,
    },
  }
}

export const CLOSE_STOCK_MODAL = 'CLOSE_STOCK_MODAL'
export const closeStockModalAction = () => {
  return {
    type: 'CLOSE_STOCK_MODAL',
    payload: {
      bread: undefined,
      date: new Date(),
      edited: false,
      open: false,
      schedules: [],
      stocks: [],
    },
  }
}

export const CLOSE_STORE_SWITCH_MODAL = 'CLOSE_STORE_SWITCH_MODAL'
export const closeStoreSwitchModalAction = () => {
  return {
    type: 'CLOSE_STORE_SWITCH_MODAL',
    payload: {
      open: false,
      store_name: '',
      store_ref: undefined,
      manufacturer_ref: undefined,
      shop_ref: undefined,
    },
  }
}

export const EDIT_CONTENT = 'EDIT_CONTENT'
export const editContentAction = () => {
  return {
    type: 'EDIT_CONTENT',
    payload: true,
  }
}

export const EDIT_STOCK_CONTENT = 'EDIT_STOCK_CONTENT'
export const editStockContentAction = () => {
  return {
    type: 'EDIT_STOCK_CONTENT',
    payload: true,
  }
}

export const INIT_EDIT_CONTENT = 'INIT_EDIT_CONTENT'
export const initEditContentAction = () => {
  return {
    type: 'INIT_EDIT_CONTENT',
    payload: false,
  }
}

export const OPEN_MODAL = 'OPEN_MODAL'
export const openModalAction = (content: React.ReactElement, description: string, title: string) => {
  return {
    type: 'OPEN_MODAL',
    payload: {
      content: content,
      description: description,
      open: true,
      title: title,
    },
  }
}

export const OPEN_BULK_STOCK_MODAL = 'OPEN_BULK_STOCK_MODAL'
export const openBulkStockModalAction = (date: string) => {
  return {
    type: 'OPEN_BULK_STOCK_MODAL',
    payload: {
      date,
      open: true,
    },
  }
}

export const OPEN_CONFIRM_MODAL = 'OPEN_CONFIRM_MODAL'
export const openConfirmModalAction = () => {
  return {
    type: 'OPEN_CONFIRM_MODAL',
    payload: {
      confirm: true,
    },
  }
}

export const OPEN_CAUTION_MODAL = 'OPEN_CAUTION_MODAL'
export const openCautionModalAction = (
  actionLabel: string,
  cancelLabel: string,
  description: string,
  onClickAction: () => void,
  title: string,
  actionType?: 'blue' | 'outlined'
) => {
  return {
    type: 'OPEN_CAUTION_MODAL',
    payload: {
      actionLabel,
      cancelLabel,
      description,
      onClickAction,
      open: true,
      title,
      actionType,
    },
  }
}

export const OPEN_SHARED_BREAD_MODAL = 'OPEN_SHARED_BREAD_MODAL'
export const openSharedBreadModalAction = (manufacturerBread: BreadType, retailerBreads: BreadType[]) => {
  return {
    type: 'OPEN_SHARED_BREAD_MODAL',
    payload: { manufacturerBread, retailerBreads, open: true },
  }
}

export const OPEN_STAFF_MODAL = 'OPEN_STAFF_MODAL'
export const openStaffModalAction = (staff: StaffType) => {
  return {
    type: 'OPEN_STAFF_MODAL',
    payload: {
      open: true,
      staff: staff,
    },
  }
}

export const OPEN_STOCK_MODAL = 'OPEN_STOCK_MODAL'
export const openStockModalAction = (bread: BreadType, schedules: ScheduleType[], stocks: StockType[], date: Date) => {
  return {
    type: 'OPEN_STOCK_MODAL',
    payload: {
      bread: bread,
      date: date,
      edited: false,
      open: true,
      schedules: schedules,
      stocks: stocks,
    },
  }
}

export const OPEN_STORE_SWITCH_MODAL = 'OPEN_STORE_SWITCH_MODAL'
export const openStoreSwitchModalAction = (
  storeName: string,
  storeRef: FirebaseDocRefType | undefined,
  storeManufacturerRef: FirebaseDocRefType | undefined,
  shopRef: FirebaseDocRefType | undefined
) => {
  return {
    type: 'OPEN_STORE_SWITCH_MODAL',
    payload: {
      open: true,
      store_name: storeName,
      store_ref: storeRef,
      manufacturer_ref: storeManufacturerRef,
      shop_ref: shopRef,
    },
  }
}

export const SET_ERROR = 'SET_ERROR'
export const setErrorAction = (error: string) => {
  return {
    type: 'SET_ERROR',
    payload: {
      error: error,
    },
  }
}

export const UPDATE_MODAL_HEADER = 'UPDATE_MODAL_HEADER'
export const updateModalHeaderAction = (description: string, title: string) => {
  return {
    type: 'UPDATE_MODAL_HEADER',
    payload: {
      description: description,
      title: title,
    },
  }
}
